'use client';

import { ReactNode, useEffect } from 'react';

import { useMobile } from '@shared/hooks';

import { ProfileSecurityDesktopLayout } from './ProfileSecurityDesktopLayout';
import { ProfileSecurityMobileLayout } from './ProfileSecurityMobileLayout';

export const ProfileSecurityLayout = ({ children }: { children: ReactNode }) => {
  const isMobile = useMobile();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className='w-full flex flex-col'>
      {isMobile ? (
        <ProfileSecurityMobileLayout>{children}</ProfileSecurityMobileLayout>
      ) : (
        <ProfileSecurityDesktopLayout>{children}</ProfileSecurityDesktopLayout>
      )}
    </div>
  );
};
